export const DEPLOYMENT_ENV = process.env.VERCEL_ENV || process.env.DEPLOYMENT_ENV; // prettier-ignore
export const NODE_ENV = process.env.NODE_ENV || 'development';
export const APP_VERSION = process.env.VERCEL_GIT_COMMIT_SHA || 'development';

export const IS_DEVELOPMENT = /development/i.test(NODE_ENV);
export const IS_PRODUCTION = /production/i.test(NODE_ENV);
export const IS_TEST = /test/i.test(NODE_ENV);
